<template>
    <div>
        <p>{{print()}}</p>
        <!-- <p>{{tmp}}</p> -->
    </div>
</template>
<script>
export default {
    props: ['x'],
    data() {
        return {
            tmp: null,
            timer: null,
        }
    },
    mounted() {
        this.tmp = this.x;
        this.startTimer()
    },
    destroyed() {
        this.stopTimer()
    },
    methods: {
        startTimer() {
            this.timer = setInterval(() => {
                this.tmp--
            }, 1000)
        },
        stopTimer() {
            clearTimeout(this.timer)
        },
        print(){
            return Math.trunc(this.tmp / 60) + ' мин. ' + (this.tmp % 60) + ' сек.'
        },
    },
    watch: {
        tmp(n) {
            if (n < 1) {
                this.stopTimer()
                this.$emit('time-is-up')
            }
        }
    },
}
</script>